import React from "react";

const HeaderBottom = () => {
  return (
    <>
      <section
        id="home"
        className="dtr-section dtr-section-with-bg dtr-hero-section-top-padding bg-blue"
        style={{
          backgroundImage:
            "url(https://i.ibb.co.com/mFBpMbNh/Screenshot-2025-02-17-T152058-575.png)",
          paddingTop: "135px",
        }}
      ></section>
    </>
  );
};

export default HeaderBottom;

